import { FileManagerInput } from 'common'
import { Button, FormControl, Grid, MenuItem, TextField } from "@mui/material"
import { DownloadCloud } from 'react-feather'


const acceptConfiguration = {
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/png': ['.png'],
    'image/webp': ['.webp']
}

export const CreditCardSection = ({ useFetchInit, dataModal }) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const { formOpeningMode } = globalStates

    const { handleClickDownloadImage } = Actions

    const { FormScreen } = Forms
    const { formState, onInputChange, onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange } = FormScreen

    return (
        <div className='content'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth> 
                        <label htmlFor="boleta_numero">* Numero de Referencia</label>
                        <TextField
                            id='boleta_numero'
                            name='boleta_numero'
                            value={ formState.boleta_numero }
                            onChange={ onInputChange }
                            size="small"
                            hiddenLabel
                            placeholder='Numero de Referencia'
                            type='text'
                            variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                            InputProps={{
                                readOnly: (formOpeningMode === 'READONLY') ? true : false
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            {(formOpeningMode==='EDITABLE')&&(
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>   
                    <FormControl fullWidth>
                        <label htmlFor="images">* Comprobante de transacción</label>
                        <FileManagerInput
                            acceptedFiles={formState.acceptedFiles}
                            fileRejections={formState.fileRejections}
                            NameId='images'
                            typeFiles='IMG'
                            maxFiles={1}
                            accept={acceptConfiguration}
                            setAcceptedFiles={onDropZoneAcceptedFilesChange}
                            setFileRejections={onDropZoneRejectionsFilesChange}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            )}

            {(formOpeningMode==='READONLY')&&(
                <>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>   
                            <FormControl fullWidth>
                                <label htmlFor="dowload-boleta">* Boleta de Deposito</label>
                                <Button
                                    startIcon={<DownloadCloud/>}
                                    color='success'
                                    variant="contained"
                                    onClick={(event) => handleClickDownloadImage( formState.boleta_foto_originalname, formState.boleta_foto_path )}
                                    sx={{textDecoration: 'none', paddingTop: 1}}
                                >Descargar</Button>
                            </FormControl>
                        </Grid>   
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <FormControl fullWidth>
                            <label htmlFor="boleta">* No. Referencia ACH</label>
                                <TextField
                                    id='aprobacion_referencia_ach'
                                    name='aprobacion_referencia_ach'
                                    value={ formState.aprobacion_referencia_ach }
                                    onChange={ onInputChange }
                                    size="small"
                                    hiddenLabel
                                    placeholder='No. Referencia ACH'
                                    type='number'
                                    variant= 'filled'
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    required
                                />   
                            </FormControl>
                        </Grid>   
                        <Grid item xs={12} sm={12} md={4} lg={4}>   
                            <FormControl fullWidth>
                                <label htmlFor="aprobacion_check">* Aprobacion</label>
                                <TextField
                                    id="aprobacion_check"
                                    name="aprobacion_check"
                                    // label="Moneda"
                                    value={formState.aprobacion_check}
                                    onChange={onInputChange}
                                    select
                                    size="small"
                                    // lable="Selecciona una opción"
                                    hiddenLabel
                                    variant='filled'
                                    InputProps={{ readOnly: true }}
                                >
                                    <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                    <MenuItem value='APROBADO'>APROBADO</MenuItem>
                                    <MenuItem value='PENDIENTE'>PENDIENTE</MenuItem>
                                    <MenuItem value='RECHAZADO'>RECHAZADO</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>     
                    </Grid>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>   
                            <FormControl fullWidth>
                            <label htmlFor="aprobacion_observaciones">Observaciones</label>
                                <TextField
                                    id='aprobacion_observaciones'
                                    name='aprobacion_observaciones'
                                    value={ formState.aprobacion_observaciones }
                                    onChange={ onInputChange }
                                    size="small"
                                    multiline
                                    rows={5}
                                    hiddenLabel
                                    placeholder='Observaciones'
                                    type='text'
                                    variant= 'filled'
                                    InputProps={{
                                        readOnly: true
                                    }}
                                />   
                            </FormControl>
                        </Grid>   
                    </Grid>
                </> 
            )}

        </div>

    )
}
